import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";


export default function AdminDeliveryConfig() {

  const [type, setType] = useState("store");

  const [slabs, setSlabs] = useState([]);
  const [courierAfter, setCourierAfter] = useState(25);
  const [useCourier, setUseCourier] = useState(true);



  // ---------------- LOAD ----------------

  useEffect(() => {
    load();
  }, [type]);


  const load = async () => {

    const res = await axios.get(
      `/admin/delivery-courier-config/?type=${type}`
    );

    setCourierAfter(res.data.courier_after_km ?? "");
setUseCourier(res.data.use_courier ?? false);
setSlabs(res.data.slabs ?? []);



 };


  // ---------------- SLABS ----------------

const addSlab = () => {
  setSlabs([
    ...slabs,
    {
      from_km: "",
      to_km: "",
      rate_type: "fixed",
      price: ""
    }
  ]);
};



  const removeSlab = (i) => {
    setSlabs(slabs.filter((_, idx) => idx !== i));
  };


  const changeSlab = (i, key, value) => {

    const copy = [...slabs];

    copy[i][key] = value;

    setSlabs(copy);
  };


  // ---------------- SAVE ----------------

const save = async () => {

  await axios.post("/admin/delivery-courier-config/", {

    type: type,   // ✅ ADD THIS

    courier_after_km: courierAfter,

    use_courier: useCourier,

    slabs: slabs

  });

  alert("Saved Successfully");

};

  // ---------------- UI ----------------

  return (
    <div style={{ padding: 20 }}>

      <h2>Delivery Pricing</h2>


      {/* TYPE */}

      <select
        value={type}
        onChange={e => setType(e.target.value)}
      >
        <option value="store">Store → Customer</option>
        <option value="hospital">Hospital → Customer</option>
      </select>


      <hr />


      {/* SLABS */}

      <h4>Distance Slabs</h4>

{slabs.map((s, i) => (

  <div
    key={i}
    style={{
      display: "flex",
      gap: 10,
      marginBottom: 10
    }}
  >

    <input
      type="number"
      placeholder="From KM"
      value={s.from_km || ""}
      onChange={e =>
        changeSlab(i, "from_km", e.target.value)
      }
    />

    <input
      type="number"
      placeholder="To KM"
      value={s.to_km || ""}
      onChange={e =>
        changeSlab(i, "to_km", e.target.value)
      }
    />

    <select
      value={s.rate_type || "fixed"}
      onChange={e =>
        changeSlab(i, "rate_type", e.target.value)
      }
    >
      <option value="fixed">Fixed</option>
      <option value="per_km">Per KM</option>
    </select>


    <input
      type="number"
      placeholder="Rate / Price"
      value={s.price || ""}
      onChange={e =>
        changeSlab(i, "price", e.target.value)
      }
    />


    <button onClick={() => removeSlab(i)}>
      ❌
    </button>

  </div>
))}



      <button onClick={addSlab}>
        ➕ Add Slab
      </button>


      <hr />


      {/* COURIER */}

<h4>Courier Settings</h4>

<div>
  Courier After (KM):
  <input
    type="number"
    value={courierAfter ?? ""}

    onChange={e => setCourierAfter(e.target.value)}
  />
</div>


<div>
  <label>
    <input
      type="checkbox"
      checked={useCourier}
      onChange={e => setUseCourier(e.target.checked)}
    />
    Enable Courier
  </label>
</div>






      <br />


      <button onClick={save}>
        💾 Save Settings
      </button>

    </div>
  );
}
